export default "__VITE_ASSET__Ctlwmb3K__"